import { Suspense, lazy } from 'react';

import { Capacitor } from '@capacitor/core';
import { Navigate, Route, Routes } from 'react-router-dom';

import PrivateRoute from '../components/PrivateRoute';
import PublicRoute from '../components/PublicRoute';
import LandingPage from '../pages/LandingPage';

const Login = lazy(() => import('../pages/Login'));
const PrivacyPolicy = lazy(() => import('../pages/PrivacyPolicy'));
const DashboardLayout = lazy(() =>
  import('../Layout/DashboardLayout').then((module) => ({
    default: module.DashboardLayout,
  })),
);
const TermsAndConditions = lazy(() => import('../pages/TermsAndConditions'));

const LoadingFallback = () => (
  <div className="flex items-center justify-center h-screen">
    <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primaryColor" />
  </div>
);

// Component to handle platform-specific home route
const PlatformHome = () => {
  // If it's a mobile app (Capacitor), redirect to login
  if (Capacitor.isNativePlatform()) {
    return <Navigate to="/login" replace />;
  }
  
  // If it's web, show the landing page
  return <LandingPage />;
};

const Router = () => (
    <Suspense fallback={<LoadingFallback />}>
      <>
        <Routes>
          <Route element={<PlatformHome />} path="/" />
          <Route
            path="/login"
            element={
              <PublicRoute>
                <Login />
              </PublicRoute>
            }
          />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route
            path="/terms-and-conditions"
            element={<TermsAndConditions />}
          />
          <Route
            path="/dashboard/*"
            element={
              <PrivateRoute>
                <DashboardLayout />
              </PrivateRoute>
            }
          />
        </Routes>
      </>
    </Suspense>
  );

export default Router;
